import SearchSuggestions from 'models/search-suggestions';

export const DISMISS_RESTRICTIONS_MODAL = 'dismiss-restrictions-modal';
const dismissRestrictionsModal = ({ currentSearch }) => ({
  type: DISMISS_RESTRICTIONS_MODAL,
  payload: { key: SearchSuggestions.suggestionKey(currentSearch) },
});
export default dismissRestrictionsModal;
